import { useGetPartnerDetailAPI } from "@/api/partners/usePartnersAPI";
import { LokasiIcon } from "@/assets/icons";
import { getSubdomain } from "@/utils/location";

import dayjs from "dayjs";

/**
 * The top of the report PDF. It has no page numbers: the page footer in
 * `report` page in `index.css` numbers the pages.
 */
export function ReportPrintHeader() {
  const { data } = useGetPartnerDetailAPI(getSubdomain());

  return (
    <div className="mb-3 flex flex-row items-center gap-3 bg-green-50 px-6 py-5">
      <div className="flex min-w-0 flex-col">
        <h1 className="break-words text-3xl font-bold text-teal-500">
          Analysis Summary
        </h1>
        <p className="text-xs font-semibold text-dim-gray">
          {dayjs().format("DD MMMM, YYYY")}
        </p>
      </div>

      {data?.app_logo_url ? (
        <img
          src={data.app_logo_url}
          className="ml-auto w-[126px] shrink-0"
          title="Lokasi"
          alt="Lokasi"
        />
      ) : (
        <LokasiIcon className="ml-auto w-[126px] shrink-0" title="Lokasi" />
      )}
    </div>
  );
}
